module.exports = __webpack_public_path__ + "static/img/img_6.c594ac1e.jpg";